/**
 * Client features — which agent pages a CLIENT (no `show_cowork`) may open.
 *
 * Staff see everything. A client sees nothing of the agent layer until Beatly opens a feature for
 * their team (backend engine/clientFeatures.ts, flipped from the staff client switcher). GET /v1/me
 * returns the team's list; this maps each feature to the pages it unlocks. Everything else stays
 * behind the show_cowork gate exactly as before.
 */
import type { CurrentPage } from '@/routes';

export const CLIENT_FEATURE_PAGES: Record<string, CurrentPage[]> = {
  reports: ['agent-reports'],
  dashboards: ['agent-dashboards'],
  brand: ['agent-brand', 'agent-brand-pulse', 'agent-brand-id', 'agent-brand-promotables', 'agent-brand-audiences', 'agent-brand-library'],
};

export const CLIENT_FEATURE_LABELS: Record<string, string> = {
  reports: 'Reports',
  dashboards: 'Dashboards',
  brand: 'Brand OS',
};

/** Pages unlocked by a feature list; unknown ids are ignored. */
export function clientPagesFor(features: readonly string[] | undefined | null): CurrentPage[] {
  const out: CurrentPage[] = [];
  for (const f of features || []) for (const p of CLIENT_FEATURE_PAGES[f] || []) if (!out.includes(p)) out.push(p);
  return out;
}

export function isClientAllowedPage(page: string, clientPages: readonly string[]): boolean {
  return clientPages.includes(page);
}
